import { Button } from "@material-ui/core";
import { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { selectIsClient } from "features/user/userSlice";
import { IconAdd } from "../../../icons";
import CreateWorkOrderPage from "features/landing/components/WorkorderDashboard/CreateWorkOrder/CreateWorkOrderPage";
import AddActivityDialog from "./AddActivityDialog";
import { filters, setFilters } from 'features/landing/components/WorkorderDashboard/CreateWorkOrder/Assets/assetsFiltersSlice';

const AddActivity = ({ vehicleId, lotId, clientId, onClose, vehicleTypeId, entityId, vehicleDetails, clientAccountId }) => {
    const [open, setOpen] = useState(false);
    const isClient = useSelector(selectIsClient);
    const dispatch = useDispatch();
    const { filters } = useSelector(state => state.assetsFilters);

    const [shouldClearClientAccount, setShouldClearClientAccount] = useState(false);

    const handleClickOpen = () => {

        const existingClientAccountId = filters?.['clientAccountId']?.value;

        // only inject if empty
        if (isClient && !existingClientAccountId && clientAccountId) {

            dispatch(setFilters({
                ...filters,
                clientAccountId: {
                    value: clientAccountId
                },
                preselectedAssets: {
                    value: [vehicleDetails]
                }
            }));

            // mark ownership
            setShouldClearClientAccount(true);
        }
        else {
            // still preload asset
            dispatch(setFilters({
                ...filters,
                preselectedAssets: {
                    value: [vehicleDetails]
                }
            }));
        }

        setOpen(true);
    };

    const handleClose = () => {

        const updatedFilters = {
            ...filters,

            // always clear temporary modal asset preload
            preselectedAssets: {
                value: []
            }
        };

        // only clear if modal created it
        if (shouldClearClientAccount) {
            updatedFilters.clientAccountId = {
                value: ''
            };
        }

        dispatch(setFilters(updatedFilters));

        setOpen(false);
        onClose();
    };

    return (
        <>
            <Button variant="contained" color="primary" onClick={handleClickOpen} startIcon={<IconAdd />}>
                Add Activity
            </Button>
            {isClient ? (
                <CreateWorkOrderPage open={open} setOpen={setOpen} />
            ) : (
                <AddActivityDialog
                    open={open}
                    setOpen={setOpen}
                    vehicleId={vehicleId}
                    lotId={lotId}
                    clientId={clientId}
                    onClose={handleClose}
                    vehicleTypeId={vehicleTypeId}
                    entityId={entityId}
                    vehicleDetails={vehicleDetails}
                />
            )}
        </>
    );
};

export default AddActivity;